/** Buffer in seconds before actual expiry to consider a token "expired". */
const EXPIRY_BUFFER_SECONDS = 30;

/**
 * Decodes the payload section of a JWT without verifying the signature.
 * Returns `null` for malformed tokens instead of throwing.
 */
function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3 || !parts[1]) return null;
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}

/**
 * Returns `true` when the token's `exp` claim is missing or the token expires
 * within the next {@link EXPIRY_BUFFER_SECONDS} seconds.
 */
export function isTokenExpired(token: string): boolean {
  const payload = decodeJwtPayload(token);
  if (!payload || typeof payload['exp'] !== 'number') return true;
  return Date.now() / 1000 >= payload['exp'] - EXPIRY_BUFFER_SECONDS;
}

/** `true` when the token was issued by the module-less PASS login, i.e. the account lacks the U_SUPP_U module. */
export function isPassModuleToken(token: string): boolean {
  return decodeJwtPayload(token)?.['module'] === 'PASS';
}
